import React from 'react';
import { useSelector } from 'react-redux';
import { getMediaPath } from '../../../../app/functions';
import './index.scss';

const ExpectationsSection = () => {
    const insurancePage = useSelector((store) => store.insurancePage);

    const expectationsData = [...insurancePage?.expectations] || [];

    expectationsData.sort(
        (a, b) => a['order_num'] - b['order_num']
    );

    return (
        <section className="expectations-section">
            <ul className="expectations-list">
                {expectationsData.map((expectationData) => (
                    <li key={expectationData?.id} className="expectation-container">
                        <img
                            src={getMediaPath(expectationData?.icon_path)}
                            alt={expectationData?.title}
                            className="expectation-icon"
                        />

                        <h2 className="expectation-title">
                            {expectationData?.title}
                        </h2>

                        <p className="expectation-description">
                            {expectationData?.description}
                        </p>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default ExpectationsSection;
